var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / Facebook",
    clipPath: "url(#clip0_118_504)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5 16.8789H20.625L21.875 11.8789H17.5V9.37891C17.5 8.09141 17.5 6.87891 20 6.87891H21.875V2.67891C21.4675 2.62516 19.9287 2.50391 18.3037 2.50391C14.91 2.50391 12.5 4.57516 12.5 8.37891V11.8789H8.75V16.8789H12.5V27.5039H17.5V16.8789Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_118_504"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.00390625)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.6941e19eac821eaf2d689ce73a36a52f.svg";
export { ForwardRef as ReactComponent };